import React from 'react';
import { motion } from 'framer-motion';
import { talentSteps } from '../mock';
import { Compass, Palette, HeartHandshake } from 'lucide-react';
import { useEnrolmentModal } from '../context/EnrolmentModalContext';

const icons = [Compass, Palette, HeartHandshake];

const Talent = () => {
  const { show } = useEnrolmentModal();
  return (
    <section className="relative py-24 md:py-32 bg-white overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-12 gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="md:col-span-5 md:sticky md:top-32"
          >
            <div className="tag-label">Parenting Insight</div>
            <h2 className="font-serif-display text-4xl md:text-6xl font-black leading-[1.05] text-[#1c1a17] mt-4">
              How to nurture your
              <br />
              <span className="italic text-[#b8331f]">child&apos;s natural talent</span>
            </h2>
            <div className="h-px w-20 bg-[#c8942a] my-8" />
            <p className="text-[#4a4238] font-light text-[15px] leading-relaxed max-w-md">
              Every child arrives with a distinct voice. Our approach blends attentive observation,
              purposeful exposure and unwavering support — the foundations on which every gift is
              refined.
            </p>
            <button type="button" onClick={() => show({ message: 'I would like to book a discovery tour.' })} className="btn-outline mt-8">Book a discovery tour</button>
          </motion.div>

          <div className="md:col-span-7 space-y-6">
            {talentSteps.map((s, i) => {
              const Icon = icons[i];
              return (
                <motion.div
                  key={s.n}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.4 }}
                  transition={{ delay: i * 0.12, duration: 0.7 }}
                  className="group flex gap-6 border border-[#eadfc9] p-7 md:p-8 bg-[#fbf7f2] hover:bg-white hover:border-[#c8942a] transition-colors"
                >
                  <div className="shrink-0 w-14 h-14 border border-[#c8942a] grid place-items-center text-[#8f6417] group-hover:bg-[#c8942a] group-hover:text-white transition-colors">
                    <Icon size={22} />
                  </div>
                  <div>
                    <div className="flex items-baseline gap-4">
                      <span className="font-serif-display text-2xl font-black text-[#c8942a]">{s.n}</span>
                      <h4 className="font-serif-display text-xl md:text-2xl font-bold text-[#1c1a17]">{s.title}</h4>
                    </div>
                    <p className="mt-3 text-[#4a4238] font-light leading-relaxed">{s.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Talent;
